import i18n from '@/utils/i18n';

const filters =
    [
        {
            "name": "users.first_name",
            "id": "first_name",
            "placeholder": i18n.t('users.first_name_placeholder'),
            "value": "",
            "type": "text",
            "label": i18n.t('users.first_name'),
            "main": false
        },
        {
            "name": "users.last_name",
            "id": "last_name",
            "placeholder": i18n.t('users.last_name_placeholder'),
            "value": "",
            "type": "text",
            "label": i18n.t('users.last_name'),
            "main": false
        },
        {
            "name": "users.email",
            "id": "email",
            "placeholder": i18n.t('users.email_placeholder'),
            "value": "",
            "type": "text",
            "label": i18n.t('users.email'),
            "main": false
        },
        {
            "name": "transactions.amount",
            "type": "price-range",
            "main": false,
            "label": i18n.t('form.price_range'),
            options: [
              {
                placeholder: i18n.t('form.from'),
                name: "from"
              },
              {
                placeholder: i18n.t('form.to'),
                name: "to"
              }
            ]
        },
        {
            "name": "transactions.created_at",
            "type": "date",
            "label": i18n.t('form.from_to_date'),
            "main": false,
            isRange: true,
        },
        {
          "name": "transactions.status",
          "label": i18n.t('form.show_only_successful_transactions'),
          "type": "checkbox",
          "main": false,
          value: 'succeeded'
        }
    ];

export default filters
